export interface CnapsBank {
  readonly code: string;
  readonly name: string;
}

export const cnapsBanks: readonly CnapsBank[] = [
  { code: '1030000', name: 'Agriculture bank of China' },
  { code: '1030001', name: 'Agriculture bank of China' },
  { code: '16649041', name: 'ALaEr JinHui County Bank Company Limited' },
  { code: '17012081', name: 'Alashanzuoqi Yellow River Village and Town Bank CO.,Ltd.' },
  { code: '16994581', name: 'AN QIU BEIHAI RURAL BANK CO.,LTD' },
  { code: '17231363', name: 'AN XIN DA SHANG COUNTY BANK Co., Ltd.' },
  { code: '15194362', name: 'Anfu BOC Fullerton Bank' },
  { code: '3480000', name: 'AnHui XinAn Bank Co.,Ltd.' },
  { code: '15003363', name: 'ANJI BOCOM RURAL BANK' },
  { code: '17107078', name: 'anlongxinglongcunzhenyinhanggufenyouxiangongsi' },
  { code: '15198045', name: 'ansai BOC Fullerton Community Bank' },
  { code: '15404960', name: 'ANYANG ZHUJIANG RURAL BANK CO,.LTD' },
  { code: '15214219', name: 'Anyi Rongxing Rural Bank' },
  { code: '16692465', name: 'BAI SHAN HUN JIANG HENG TAI COUNTRY BANK CO.,LTD' },
  { code: '15212659', name: 'Baiquan Rongxing Rural Bank' },
  { code: '15536266', name: 'BAISE JINGXI  CHANGJIANG RURAL BANK CORPORATION LIMITED' },
  { code: '17382466', name: 'BAISHAN JIANGYUAN HUIHENG VILLAGEBAN CO.LTD' },
  { code: '16881325', name: 'Baixiang Rongxin Rural Bank Stock Co.Ltd' },
  { code: '15175810', name: 'Baiyun Mintai Rural Bank Of Guangzhou' },
  { code: '65520000', name: 'BANK OF BAODING CO.,LTG.' },
  { code: '4031000', name: 'Bank of Beijing' },
  { code: '65492340', name: 'BANK OF CHAOYANG' },
  { code: '1040000', name: 'BANK OF CHINA' },
  { code: '3010000', name: 'Bank of communications' },
  { code: '65576750', name: 'bank of dazhou' },
  { code: '16087081', name: 'Bank of DeXin Village,BaiYun GuiYang Co.Ltd' },
  { code: '5818201', name: 'BANK OF GANSU' },
  { code: '4437010', name: 'BANK OF GUIYANG CO. LTD' },
  { code: '5886400', name: 'BANK OF HAINAN CO.,LTD' },
  { code: '5705500', name: 'Bank of Hunan Corporation Limited' },
  { code: '5083001', name: 'BANK OF JIANGSU CO.,LTD' },
  { code: '5213000', name: 'Bank of Jiangsu Credit Card' },
  { code: '4062419', name: 'Bank of Jilin' },
  { code: '64540000', name: 'bank of jiujiang' },
  { code: '4721460', name: 'Bank of Langfang Co., Ltd.' },
  { code: '4368710', name: 'BANK OF NINGXIA' },
  { code: '4504790', name: 'BANK OF QINGDAO CO.,LTD LAIWU BRANCH' },
  { code: '4012902', name: 'Bank of Shanghai' },
  { code: '4283379', name: 'BANK OF SHAOXING CO.,LTD' },
  { code: '4991240', name: 'BANK OF TANGSHAN CO.,LTD.' },
  { code: '4341100', name: 'Bank of Tianjin Co., Ltd.' },
  { code: '4270001', name: 'Bank of Urumqi' },
  { code: '4278810', name: 'Bank of Urumqi' },
  { code: '64652280', name: 'BANK OF YINGKOU' },
  { code: '4901380', name: 'BANK OF ZHANGJIAKOU CO LTD' },
  { code: '3590000', name: 'Bank SinoPac(China)Ltd.' },
  { code: '16171341', name: 'BAODING MANCHENG LIFENG RURAL BANK' },
  { code: '17091342', name: 'BaoDing QingYuan District Xtrcb Rural Bank Corporation Limit' },
  { code: '16702682', name: 'BAOQING GENEROUS INTENT VILLAGE BANK' },
  { code: '15537535', name: 'BAOSHAN CHANGNING CHANGJIANG RURAL BANK CORPORATION LIMITED' },
  { code: '15537534', name: 'BAOSHAN LONGLING CHANGJIANG RURAL BANK CORPORATION LIMITED' },
  { code: '15537532', name: 'BAOSHAN SHIDIAN CHANGJIANG RURAL BANK CORPORATION LIMITED' },
  { code: '15212620', name: 'Bayan Rongxing Rural Bank' },
  { code: '15196874', name: 'bazhong BOC Fullerton Community Bank' },
  { code: '15151000', name: 'Beijing Daxing Jiuyin County Bank' },
  { code: '15211039', name: 'Beijing Huairou Rongxing Rural Bank' },
  { code: '15401000', name: 'Beijing Mentougou Zhujiang Rural Bank' },
  { code: '15181035', name: 'Beijing Pinggu Xinhua Villiage Township Bank' },
  { code: '15191031', name: 'Beijing tongzhou BOC Fullerton Community Bank' },
  { code: '16611028', name: 'BEIJING YANQING VILLAGE BANK CORPORATION' },
  { code: '3550000', name: 'Beijing Zhongguancun Bank Corporation Limited' },
  { code: '16222346', name: 'Beipiao Shengdu Rural Bank Co.,Ltd.' },
  { code: '16942256', name: 'Benxi Fengtai Village Bank Co., Ltd' },
  { code: '17114668', name: 'BINZHOU HEHAI RURAL BANK' },
  { code: '3510000', name: 'BLUE OCEAN BANK' },
  { code: '15191365', name: 'BOC Fullerton Community Bank Co.,Ltd.' },
  { code: '15521430', name: 'Cang xian ji yin rural bank' },
  { code: '15193336', name: 'cangnan BOC Fullerton Community Bank' },
  { code: '15194752', name: 'Caoxian BOC Fullerton Bank' },
  { code: '16692419', name: 'CHANG CHUN JING KAI RONGFENG COUNTRY BANK CO.,LTD' },
  { code: '17342416', name: 'CHANG CHUN JING YUE YU YIN VILLAGE BANK CO.,LTD' },
  { code: '16692417', name: 'CHANG CHUN KUAN CHENG RONGHUI COUNTRY BANK CO.,LTD' },
  { code: '16692481', name: 'CHANG CHUN LVYUAN RONGTAI COUNTRY BANK CO.,LTD' },
  { code: '15522410', name: 'Chang chun shuang yang ji yin rural bank' },
  { code: '15551262', name: 'Chang Li Jia Yin County Bank Co., Ltd.' },
  { code: '16994585', name: 'CHANG YI BEIHAI RURAL BANK CO.,LTD' },
  { code: '5417900', name: 'Changan Bank' },
  { code: '17342463', name: 'Changbai Yuyin Village Bank Co., Ltd' },
  { code: '4062410', name: 'ChangChun commercial bank' },
  { code: '64720000', name: 'CHANGCHUN DEVELOPMENT RURAL COMMERCIAL BANK' },
  { code: '15802416', name: 'CHANGCHUN NANGUAN HUIMIN Village Bank Company Limited' },
  { code: '61100000', name: 'CHANGCHUN RURAL COMMERCIAL BANK' },
  { code: '16692418', name: 'CHANGCHUNCHAOYANG HERUN COUNTRY BANK CO.,LTD' },
  { code: '16332361', name: 'CHANGFENG RURAL BANK OF SUIZHONG' },
  { code: '15535894', name: 'CHANGJIANG RURAL BANG CORPORALITED' },
  { code: '15404790', name: 'Changningzhujiangruralbank' },
  { code: '15405545', name: 'Changningzhujiangruralbank' },
  { code: '4615510', name: 'Changsha City Commercial Bank' },
  { code: '15193055', name: 'changshu BOC Fullerton Community Bank' },
  { code: '15197958', name: 'changwu BOC Fullerton Community Bank' },
  { code: '16332363', name: 'CHANGXING RURAL BANK OF XINGCHENG' },
  { code: '15533046', name: 'CHANGZHOU ZHONGLOU CHANGJIANG RURAL BANG CORPORALITED' },
  { code: '14916040', name: 'Chaozhou Rural Commercial Bank Co.,Ltd.' },
  { code: '16041411', name: 'Chengde county Hengsheng county Bank' },
  { code: '4296510', name: 'ChengDu City Commercial Bank CO LTD' },
  { code: '15196514', name: 'Chengdu pidu BOC Fullerton Community Bank' },
  { code: '14226510', name: 'Chengdunongcun Commercial bank' },
  { code: '15216528', name: 'ChengDuQingBaiJiang Rongxing Rural Bank' },
  { code: '15197993', name: 'chenggu BOC Fullerton Community Bank' },
  { code: '15595866', name: 'CHENGHAI CHAOSHANG COUNTY BANK' },
  { code: '15551402', name: 'Chicheng Jiayin County Bank Co.,Ltd.' },
  { code: '17001951', name: 'Chifeng Hongshan Yulong Country Bank Company Co.Ltd' },
  { code: '17001952', name: 'Chifeng Yuanbaoshan Yulong Country Bank Company Limited' },
  { code: '3620000', name: 'CHINA CITIC BANK INTERNATIONAL' },
  { code: '1050000', name: 'China Construction Bank' },
  { code: '1050001', name: 'China Construction Bank' },
  { code: '3030000', name: 'China Everbright Bank' },
  { code: '63030000', name: 'China Everbright Bank' },
  { code: '15197043', name: 'chishui BOC Fullerton Community Bank' },
  { code: '17091403', name: 'Chonglixing Rural Commercial Bank Co., Ltd' },
  { code: '15196900', name: 'Chongqing Changshou BOC Fullerton Bank' },
  { code: '15196922', name: 'Chongqing Chengkou BOC Fullerton Community Bank' },
  { code: '4416900', name: 'Chongqing City Commercial bank' },
  { code: '15216920', name: 'Chongqing Dadukou Rongxing Rural Bank' },
  { code: '15196929', name: 'Chongqing Fengjie BOC Fullerton Bank' },
  { code: '15196902', name: 'Chongqing Hechuan BOC Fullerton Bank' },
  { code: '16506938', name: 'CHONGQING JIANGBEI HENGFENG RURAL BANK' },
  { code: '15176900', name: 'CHONGQING JIULONGPO MINTAI COUNTRY BANK CO.,LTD' },
  { code: '15176936', name: 'CHONGQING PENGSHUI MINTAI RURAL BANK CO.,LTD' },
  { code: '15216937', name: 'Chongqing Shapingba Rongxing Rural Bank' },
  { code: '15196933', name: 'Chongqing Shizhu BOC Fullerton Bank' },
  { code: '15216930', name: 'Chongqing Wulong Rongxing Rural Bank' },
  { code: '15196931', name: 'Chongqing Wushan BOC Fullerton Bank' },
  { code: '16616934', name: 'CHONGQING XIUSHAN BOB RURAL BANK CO., LTD.' },
  { code: '16616941', name: 'Chongqing Yongchuan BOB Rural Bank Co., Ltd.' },
  { code: '15216939', name: 'Chongqing Youyang Rongxing Rural Bank' },
  { code: '16506928', name: 'CHONGQING YUNYANG HENGFENG RURAL BANK' },
  { code: '15154375', name: 'CHONGREN JIUYIN COUNTY BANK CO.,LTD' },
  { code: '15536364', name: 'CHONGZUO DAXIN  CHANGJIANG RURAL BANK CORPORATION LIMITED' },
  { code: '15193316', name: 'chunan BOC Fullerton Community Bank' },
  { code: '15197961', name: 'chunhua BOC Fullerton Community Bank' },
  { code: '15687381', name: 'CHUXIONG HONGTA RURAL BANK CO.,LTD.' },
  { code: '3020000', name: 'CITIC  bank' },
  { code: '3570000', name: 'CITIC aiBank Corporatiom Limited' },
  { code: '63020000', name: 'Citic Bank forCredit Card' },
  { code: '15193325', name: 'cixi BOC Fullerton Community Bank' },
  { code: '17177144', name: 'CONGJIANG YUEMING VILLAGE BANK' },
  { code: '16221661', name: 'CZSD District Taidu Village Bank Co.,Ltd' },
  { code: '15802474', name: 'DAAN HUIMIN Village Bank Company Limited' },
  { code: '15196752', name: 'dachuan BOC Fullerton Community Bank' },
  { code: '16221715', name: 'DAIXIAN HONGDU VILLAGE BANK' },
  { code: '15192052', name: 'dalate BOC Fullerton Community Bank' },
  { code: '15537514', name: 'DALI BINCHUAN CHANGJIANG RURAL BANK CORPORATION LIMITED' },
  { code: '15537521', name: 'DALI ERYUAN CHANGJIANG RURAL BANK CORPORATION LIMITED' },
  { code: '15537517', name: 'DALI WEISHAN CHANGJIANG RURAL BANK CORPORATION LIMITED' },
  { code: '4202220', name: 'Dalian City Commercial Bank' },
  { code: '14620000', name: 'Dalian rural commercial bank' },
  { code: '15402220', name: 'DalianZJRB' },
  { code: '16561923', name: 'DAMAOQI MengShang Rural Bank' },
  { code: '16041281', name: 'DAMING HENGSHENG COUNTY BANK' },
  { code: '15197036', name: 'daozhen BOC Fullerton Community Bank' },
  { code: '15198511', name: 'datong BOC Fullerton Community Bank' },
  { code: '15195221', name: 'daye BOC Fullerton Community Bank' },
  { code: '15006518', name: 'DAYI XINGMIN VILLAGE OR TOWNSHIP BANK' },
  { code: '15385822', name: 'DAZHONG RURAL BANK OF SHIXING CORPORATION LIMITED' },
  { code: '15382074', name: 'DAZHONG Rural Bank OF WULATEQIANQI Co.Ltd' },
  { code: '17012413', name: 'DEHUI DUNYIN VILLAGE BANK CO.,LTD' },
  { code: '17197057', name: 'DEJIANG CHANGZHENG RURAL BANK CO.,LTD.' },
  { code: '17137121', name: 'DEPARTMENT OF ZHENNING VILLAGE BANK Co.Ltd' },
  { code: '16844342', name: 'DEXING BLUE OCEAN COMMUNITY BANK CO.,LTD' },
  { code: '15196924', name: 'dianjiang BOC Fullerton Community Bank' },
  { code: '17114753', name: 'DINGTAO HEHAI RURAL BANK CO.,LTD' },
  { code: '16691356', name: 'Dingxing Fengyuan County Bank' },
  { code: '15406020', name: 'Dongguang Huangjaing Zhujaing Rural Bank Co.,Ltd' },
  { code: '15194761', name: 'Dongming BOC Fullerton Bank' },
  { code: '15154248', name: 'DUCHANG JIUYIN COUNTY BANK CO.LID.' },
  { code: '15177715', name: 'Dui Long Mintai Rural Bank of Tibet' },
  { code: '16692493', name: 'Dunhua Jiangnan Village Town Bank Co.Ltd.' },
  { code: '16087151', name: 'DUYUN RONGTONG TOWN BANK' },
  { code: '15055411', name: 'Enshi Country Bank' },
  { code: '3110000', name: 'Ever growing bank' },
  { code: '15724296', name: 'EVERBRIGHT RARUL BANK CO.LTD' },
  { code: '15193622', name: 'fanchang BOC Fullerton Community Bank' },
  { code: '16041286', name: 'FEIXIANG HENGSHENG COUNTY BANK' },
  { code: '15197038', name: 'fenggang BOC Fullerton Community Bank' },
  { code: '15191425', name: 'fengning BOC Fullerton Community Bank' },
  { code: '15197932', name: 'Fengxiang BOC Fullerton Community Bank' },
  { code: '15154315', name: 'FENGXIN JIUYIN COUNTY BANK CO.,LTD' },
  { code: '16942253', name: 'Fengye Village Bank Of Benxi' },
  { code: '16221731', name: 'FENYANG JIU DU RURAL BANK' },
  { code: '15154261', name: 'FENYI JIUYIN COUNTY BANK CO.,LTD' },
  { code: '17231368', name: 'FU PING DA SHANG COUNTY BANK Co.,Ltd.' },
  { code: '15077934', name: 'FuFeng  SPD RURAL Bank Co.,' },
  { code: '15625082', name: 'FUGOU ZHENGYIN VILLAGE BANK COMPANY LTD' },
  { code: '14173900', name: 'Fujian Rural Credit Union' },
  { code: '65173900', name: 'Fujian Rural Credit Union Credit Card' },
  { code: '15196904', name: 'fuling BOC Fullerton Community Bank' },
  { code: '15193728', name: 'Funan BOC Fullerton Bank' },
  { code: '15404560', name: 'Fushanzhujiangruralbank' },
  { code: '17272243', name: 'Fushun Qingyuan rural bank Co.,Ltd.' },
  { code: '17342461', name: 'Fusong Yuyin Village Bank Co., Ltd' },
  { code: '15572291', name: 'FUXINCOUNTRYBANK' },
  { code: '15544381', name: 'Fuzhou Dongxiang Fumin Rural Bank Co.Ltd' },
  { code: '15193092', name: 'gaochunwujiazui BOC Fullerton Community Bank' },
  { code: '14265930', name: 'Gaoyao Rural Credit Union' },
  { code: '16041462', name: 'GUAN HENGSHENG COUNTY BANK' },
  { code: '3033320', name: 'Guang Da Bank' },
  { code: '16506695', name: "GUANG'AN HENGFENG RURAL BANK" },
  { code: '15494382', name: 'Guangchang Nanyin Rural Bank' },
  { code: '14870000', name: 'Guangdong Haifeng Rural Commercial Bank Co.,Ltd' },
  { code: '14075882', name: 'Guangdong Nanhai Rural Commercial Bank Company Limited' },
  { code: '15596054', name: 'Guangdong Puning Huicheng County Bank' },
  { code: '14505800', name: 'GuangDong rural credit bank' },
  { code: '14915823', name: 'GuangdongNanxiongRuralCommercialBankCo.,Ltd' },
  { code: '15406584', name: 'Guanghan Zhujiang Rural Bank' },
  { code: '15696246', name: 'GUANGXI BEILIU LIUYIN COUNTRY BANK Co.,Ltd' },
  { code: '15696248', name: 'GUANGXI BOBAI LIUYIN COUNTRY BANK Co.,Ltd' },
  { code: '15696141', name: 'GUANGXI LIUJIANG LIUYIN COUNTRY BANK Co.,Ltd' },
  { code: '15696247', name: 'GUANGXI LUCHUAN LIUYIN COUNTRY BANK Co.,Ltd' },
  { code: '15696158', name: 'GUANGXI RONGSHUI LIUYIN COUNTRY BANK Co.,Ltd' },
  { code: '15696249', name: 'GUANGXI XINGYE LIUYIN COUNTRY BANK Co.,Ltd' },
  { code: '14436103', name: 'guangxinongcunxinyonglianheshe' },
  { code: '15695812', name: 'GUANGZHOU CONGHUA LIUYIN COUNTRY BANK Co.,Ltd' },
  { code: '14055810', name: 'GuangZhou Rural Credit Union' },
  { code: '15535813', name: 'GuangZhou ZengCheng ChangJiang Rural Bank CO.,LTD' },
  { code: '15195284', name: 'Gucheng BOC Fullerton bank' },
  { code: '4916170', name: 'Guilin Bank' },
  { code: '15154271', name: 'GUIXI JIUYIN COUNTY BANK CORPORATION LIMITED' },
  { code: '14860000', name: 'Guiyang Rural Commercial Bank' },
  { code: '14367000', name: 'Guizhou Rural Credit Coopration' },
  { code: '15421614', name: 'GUJIAO HUIZE VILLAGE BANK' },
  { code: '14636410', name: 'Haikou Rural Commercial Bank CO.,LTD' },
  { code: '14616410', name: 'Haikou United Rural Commercial Bank,.Ltd' },
  { code: '15193065', name: 'haimen BOC Fullerton Community Bank' },
  { code: '15404564', name: 'Haiyangzhujiangruralbank' },
  { code: '15198011', name: 'hanbin BOC Fullerton Community Bank' },
  { code: '5170000', name: 'HANDANYINHANG' },
  { code: '5075210', name: 'HANKOU BANK CO.,LTD.' },
  { code: '15803652', name: 'HANSHAN HUIMIN Village Bank Company Limited' },
  { code: '15422051', name: 'HANTAI VILLAGE BANK' },
  { code: '15237991', name: 'HANZHONG HANTAI PUZHEN JULI RURAL BANK' },
  { code: '4422610', name: 'HARBIN  CITY  COMMERCIAL  BANK  Co.,Ltd.' },
  { code: '64422611', name: 'Harbin Bank Limited Company' },
  { code: '14840000', name: 'Hebei Lizhou BOB Rural Commercial Bank Company Limited' },
  { code: '15211440', name: 'Hejian Ronghui Rural Bank' },
  { code: '16221818', name: 'HeJin City LongDu Village Bank CO.,LTD' },
  { code: '17012496', name: 'HELONG DUNYIN VILLAGE BANK CO.,LTD' },
  { code: '16135117', name: 'henan runan tailong village bank' },
  { code: '14404900', name: 'Henan Rural Credit Cooperative' },
  { code: '14411200', name: 'Henan rural credit union' },
  { code: '16134952', name: 'henan yexian tailong village bank' },
  { code: '16691482', name: 'Hengshui Jizhou Fengyuan Village Bank' },
  { code: '15405895', name: 'Heshan Zhujiang Rural Bank' },
  { code: '16221754', name: 'HeShun County GuiDu Village Bank CO.,LTD' },
  { code: '16994751', name: 'HEZEMUDAN BEIHAI RURAL BANK CO.,LTD' },
  { code: '15216437', name: 'HNBT RongXing Village Township Bank Limited Company' },
  { code: '4741910', name: 'Hohhot City Commercial Bank' },
  { code: '15142061', name: 'Hohhot City Yu Quan Meng Yin Rural Bank Co.,Ltd' },
  { code: '15215399', name: 'Honghu Rongxing Rural Bank' },
  { code: '16221776', name: 'HONGTONG HONGDU VILLAGE BANK' },
  { code: '65385500', name: 'Hu Nan Rural Commercial Bank' },
  { code: '15212722', name: 'Huachuan Rongxing Rural Bank' },
  { code: '16171399', name: 'HuaiLai LiFeng County Bank Ltd' },
  { code: '15195088', name: 'huaiyang BOC Fullerton Community Bank' },
  { code: '15212721', name: 'HuaNan Rongxing Rural Bank' },
  { code: '15195339', name: 'HuangMei BOC Fullerton Community Bank' },
  { code: '17167132', name: 'HUANGPING ZHENXING VILLAGE BANK' },
  { code: '5535220', name: 'HuangShi Bank' },
  { code: '16838512', name: 'HUANGZHONG SANJIANG RURAL BANK' },
  { code: '3040000', name: 'HuaXia Bank Co.,Ltd' },
  { code: '15194964', name: 'Huaxian BOC Fullerton Community Bank' },
  { code: '15252434', name: 'HUAXING COUNTRY BANK CO., LTD.' },
  { code: '5755200', name: 'Hubei Bank' },
  { code: '14105200', name: 'Hubei Rural Credit Union' },
  { code: '17221667', name: 'HuGuan County JinRong Community Bank CO.,LTD' },
  { code: '16087032', name: 'Hui Long Town Bank' },
  { code: '15801469', name: 'HuiMin Village Bank Of Anci Langfang' },
  { code: '17342452', name: 'Huinan Yuyin Village Bank Co.,Ltd' },
  { code: '15218249', name: 'Huininghuishi  Rural Bank' },
  { code: '15173020', name: 'HuiShan Mintai Rural Bank Of JiangSu' },
  { code: '4403600', name: 'HuiShang Bank' },
  { code: '4403601', name: 'HUISHANG BANK CORPORATION LIMITED' },
  { code: '15404988', name: 'Huixian Zhujiang Rural Bank' },
  { code: '15154249', name: 'HUKOU JIUYIN COUNTY BANK CO.,LTD' },
  { code: '16912364', name: 'HULUDAO GUOXIN RURAL BANK' },
  { code: '15522494', name: 'HUN CHUN JI YIN RURAL BANK' },
  { code: '5910000', name: 'HuNan BANK OF SANXIANG Co.,Ltd' },
  { code: '14385500', name: 'HUNAN RURAL CREDIT UNION' },
  { code: '16591635', name: 'HunYuan HuiRong County Bank Corp.' },
  { code: '16648853', name: 'HuTuBi JinHui Country Bank  Company Limited' },
  { code: '16561914', name: 'Inner Mongolia Helingeer Meng Shang Village Bank Co.,Ltd' },
  { code: '1020000', name: 'Insdustrial and Commercial bank of China' },
  { code: '16692455', name: 'JI AN HUI XIN COUNTRY BANK CO.,LTD' },
  { code: '17342427', name: 'JI LIN CHANG YI YU YIN VILLAGE BANK CO.,LTD' },
  { code: '16332362', name: 'JIANCHANG RURAL BANK OF XINGCHENG' },
  { code: '17197052', name: 'JIANGKOU CHANGZHENG RURAL BANK CO.,LTD.' },
  { code: '15193415', name: 'jiangshan BOC Fullerton Community Bank' },
  { code: '16973071', name: 'JIANGSU GANYU XINGFU COUNTRY BANK' },
  { code: '15173120', name: 'JIANGSU HANJIANG MINTAI COUNTY BANK CO.LTD' },
  { code: '15523120', name: 'Jiangsu jiangdu jiyin rural bank' },
  { code: '15403066', name: 'Jiangsu Qidong Zhujiang Rural Bank' },
  { code: '15213069', name: 'Jiangsu Rudong Rongxing Rural Bank' },
  { code: '3500000', name: 'Jiangsu Suning Bank CO.,LTD.' },
  { code: '15403088', name: 'Jiangsu Xuyi Zhujiang Rural Bank' },
  { code: '15544314', name: 'Jiangxi Gaoan Fumin Rural Bank Co.,Ltd' },
  { code: '15544317', name: 'Jiangxi Shanggao Fumin Rural Bank Co.,Ltd' },
  { code: '15544232', name: 'Jiangxi Shangli fumin Rural Back Co.Ltd.' },
  { code: '15544316', name: 'Jiangxi Wanzai Fumin Rural Bank Co.Ltd' },
  { code: '3600000', name: 'Jiangxi Yumin Bank Co.Ltd' },
  { code: '15195379', name: 'Jianli BOC Fullerton bank' },
  { code: '16902342', name: 'Jianping Hongshan Rural Bank Co.,Ltd.' },
  { code: '15522424', name: 'JIAOHE JIYIN RURAL BANK' },
  { code: '16221744', name: 'JIAOKOU RONGDU VILLAGE BANK' },
  { code: '15083351', name: 'Jiashan United Rural Bank' },
  { code: '16264954', name: 'JIAXIAN GUANGTIAN COUNTY BANK CO.,LTD' },
  { code: '15194616', name: 'Jiaxiang BOC Fullerton Bank' },
  { code: '15193731', name: 'Jieshou BOC Fullerton Bank' },
  { code: '16221761', name: 'JIEXIU HUADU VILLAGE BANK' },
  { code: '14452400', name: 'JILIN PROVINCE RURAL CREDIT UNION' },
  { code: '14452402', name: 'Jilin Rural Credit Union' },
  { code: '16676511', name: 'JIN TANG HUI JIN RURAL BANK' },
  { code: '16994517', name: 'JINAN GAOXIN BEIHAI RURAL BANK CO.LTD' },
  { code: '17187133', name: 'JINDING VILLAGE BANK OF SHIBING' },
  { code: '16692462', name: 'JING YU QIAN FENG COUNTRY BANK LIMITED BY SHARE LTD' },
  { code: '15154319', name: 'JINGAN JIUYIN COUNTY BANK CO.,LTD' },
  { code: '15198332', name: 'jingchuan BOC Fullerton Community Bank' },
  { code: '15154223', name: 'JINGDEZHENCHANGJIANG JIUYIN COUNTY BANK CO.,LTD' },
  { code: '15154352', name: 'JINGGANGSHAN JIU YIN VILLAGES AND SMALL BANK CO.,LTD' },
  { code: '15805324', name: 'JINGMEN DONGBAO HUIMIN Village Bank Company Limited' },
  { code: '15195321', name: 'Jingshan BOC Fullerton bank' },
  { code: '16691491', name: 'Jingxian Fengyuan County Bank Co.,Ltd.' },
  { code: '16648856', name: 'JINHUI VILLAGE BANK OF FUKANG' },
  { code: '16648890', name: 'JINHUI VILLAGE BANK OF TIEMENGUAN' },
  { code: '15173089', name: 'JinHun Mintai Rural Bank Of JiangSu' },
  { code: '16844611', name: 'JINING BLUE OCEAN COMMUNITY BANK CO.,LTD' },
  { code: '16714611', name: 'JINING HIGH-TECH COUNTY BANK CO.,LTD.' },
  { code: '16934611', name: 'JINING RUSHANG RURAL BANK CO.,LTD.' },
  { code: '15494214', name: 'JinXian RuiFeng Country Bank Co.Ltd' },
  { code: '17332271', name: 'JinZhou SongShan Rural Commercial Community Bank Co.,Ltd' },
  { code: '15852270', name: 'Jinzhou Taihe Jinyin  Rural  Bank  Co. , Ltd' },
  { code: '17251817', name: 'JiShan County HeDong Village Bank CO.,LTD' },
  { code: '4544240', name: 'Jiujiang City Commercial Bank' },
  { code: '64710000', name: 'Jiutai Rural Commercial Bank CO.,LTD(Credit Card)' },
  { code: '16631782', name: 'JIXIANXINTIANVILLAGEBANK' },
  { code: '16994514', name: 'JIYANG BEIHAI RURAL BANK CO.LTD' },
  { code: '16641125', name: 'Jizhou Village Bank of Tianjin Co.,Ltd' },
  { code: '15404350', name: 'Jizhou Zhujiang Rural Bank' },
  { code: '17382428', name: 'JLLTHYCZYHGFYXGS' },
  { code: '16881331', name: 'Julu Rongxin Rural Bank Stock Co.Ltd' },
  { code: '15194756', name: 'Juye BOC Fullerton Bank' },
  { code: '16087131', name: 'KAILI DONGNAN TOWN BANK' },
  { code: '17001947', name: 'Kalaqin Yulong Country Bank Company Co.Ltd' },
  { code: '15551392', name: 'KANGBAO YINFENG VILLAGE BANK' },
  { code: '15422050', name: 'KANGBASHI VILLAGE BANK' },
  { code: '17281421', name: 'KUAN CHENG RONG XING COUNTY BANK' },
  { code: '16952264', name: 'Kuan Dian Bai Feng Rural Bank Company Limited' },
  { code: '4667310', name: 'Kunming commercial bank' },
  { code: '15536352', name: 'LAIBIN XIANGZHOU CHANGNING CHANGJIANG RURAL BANK CORPORATION' },
  { code: '16171361', name: 'Laishui Lifeng County Bank Inc' },
  { code: '15404569', name: 'Laizhou Zhujiang Rural Bank' },
  { code: '16881471', name: 'Langfang Development Zone Rongshang County Bank Co.,Ltd' },
  { code: '15216743', name: 'LangZhong Rongxing Rural Bank' },
  { code: '15197912', name: 'lantian BOC Fullerton Community Bank' },
  { code: '4478210', name: 'Lanzhou bank' },
  { code: '15195287', name: 'Laohekou BOC Fullerton bank' },
  { code: '16838523', name: 'LEDU SANJIANG RURAL BANK' },
  { code: '15215549', name: 'Leiyang Rongxing Rural Bank' },
  { code: '15214229', name: 'Leping Rongxing Rural Bank' },
  { code: '17262246', name: 'Liao Ning Shen Dong Rural Bank Company Limited' },
  { code: '15852272', name: 'LIAOMING LINGHAI RURAL BANK COLTD' },
  { code: '15852273', name: 'Liaoning Beizhen Jinyin Rural Bank Co., Ltd' },
  { code: '15752282', name: 'liaoNing ChenZhou HuiTong Town Bank' },
  { code: '15752281', name: 'LIAONING DASHIQIAO LONGFENG RURAL BANK' },
  { code: '15852274', name: 'Liaoning Heishan Jinyin Rural Bank Co., Ltd' },
  { code: '15852252', name: 'LIAONING HUANREN RURAL BANK COLTD' },
  { code: '14542200', name: 'Liaoning Rural Credit Cooperatives' },
  { code: '14540001', name: 'Liaoning Rural Credit Cooperatives' },
  { code: '14542201', name: 'Liaoning Rural Credit Cooperatives' },
  { code: '5930000', name: 'LIAOSHEN BANK CO.,LTD' },
  { code: '17342443', name: 'LIAOYUAN LONGSHAN YUYIN VILLAGE BANK CORP.,LTD.' },
  { code: '17342444', name: 'Liaoyuan XianQu Yuyin Village Bank Co., Ltd..' },
  { code: '4314730', name: 'Linfen City Commercial Bank' },
  { code: '16221771', name: 'LinFen City YaoDu District HuiDu Village Bank CO.,LTD' },
  { code: '17211634', name: 'Lingqiu County Changqing Village BANK CO.LTD' },
  { code: '15806436', name: 'LINGSHUI HUIMIN VILLAGE BANK CO.,LTD' },
  { code: '16462343', name: 'LINGYUAN TIANYUAN VILLAGE BANK CO.,LTD' },
  { code: '15193724', name: 'Linquan BOC Fullerton Community Bank' },
  { code: '16024744', name: 'LINSHU MINFENG COUNTRY BANK CO.,LTD' },
  { code: '15196693', name: 'Linshui BOC Fullerton Community Bank' },
  { code: '16221736', name: 'LINXIAN QUANDU VILLAGE BANK' },
  { code: '15194689', name: 'Linyi BOC Fullerton Bank' },
  { code: '3134730', name: 'Linyi Commercial bank' },
  { code: '15195042', name: 'Linying BOC Fullerton Bank' },
  { code: '16664961', name: 'LINZHOU ZHONGYUAN COUNTY BANK Co.,LTD' },
  { code: '16692431', name: 'LISHU YUANTAI RONGTAI COUNTRY BANK CO.,LTD' },
  { code: '15193431', name: 'lishuiliandu BOC Fullerton Community Bank' },
  { code: '15421737', name: 'LIULIN HUIZE VILLAGE BANK' },
  { code: '4956140', name: 'Liuzhou City Commercial Bank' },
  { code: '17298744', name: 'Longde Liupanshan Rural Bank' },
  { code: '4922600', name: 'Longjiang bank' },
  { code: '17342495', name: 'Longjing Yuyin Village Bank Co.,Ltd' },
  { code: '15194567', name: 'longkou BOC Fullerton nanshan Community Bank' },
  { code: '16087017', name: 'LONGLI GUOFENG RURAL BANK' },
  { code: '15173439', name: 'LONGQUAN MINTAI RURAL BANK OF ZHEJIANG' },
  { code: '15551264', name: 'Lu Long Jia Yin County Bank Co., Ltd.' },
  { code: '15803614', name: 'LuJiang HuiMin village Bank Company Limited' },
  { code: '17367158', name: 'Luodian Development Rural Bank Co.Ltd' },
  { code: '15154247', name: 'LUSHAN JIUYIN ART COUNTY BANK CO.,LTD' },
  { code: '16665054', name: 'LUSHI ZHONGYUAN VILLAGE BANK Co.,Ltd.' },
  { code: '15535922', name: 'MAOMING GAOZHOU CHANGJIANG RURAL BANG CORPORALITED' },
  { code: '15197039', name: 'meitan BOC Fullerton Community Bank' },
  { code: '3540000', name: 'MEIZHOU HAKKA BANK CO.,LTD.' },
  { code: '16881452', name: 'Mengcun Hui Autonomous County Rongxin Village Bank Co., Ltd' },
  { code: '4791920', name: 'MENGSHANG BANK CO.,LTD' },
  { code: '4791921', name: 'MENGSHANG BANK CO.,LTD' },
  { code: '15195576', name: 'miluo BOC Fullerton Community Bank' },
  { code: '17082753', name: 'MULINGFAREASTVILLAGEANDTOWNSHIPBANKCOMPANYLIMITED' },
  { code: '15196907', name: 'nanan BOC Fullerton Community Bank' },
  { code: '15154215', name: 'NANCHANG CHANGDONG JIUYIN COUNTY BANK CORPORATION LIMITED' },
  { code: '15494210', name: 'NanChang DaFeng Country Bank Co.Ltd' },
  { code: '15544372', name: 'Nancheng Fumin Rural Bank Co.Ltd' },
  { code: '15494374', name: 'NanFeng JuDu Country Bank' },
  { code: '16881328', name: 'Nanhe Rongxin Rural Bank Stock Co.Ltd' },
  { code: '16221638', name: 'NANJIAO JINGDU VILLAGE BANK' },
  { code: '15153010', name: 'NANJING LIUHE JIUYIN COUNTY BANK CORPORATION LIMITED' },
  { code: '4786110', name: 'NanNing Commercial Bank' },
  { code: '15536125', name: 'NANNING LONGAN  CHANGJIANG RURAL BANK CORPORATION LIMITED' },
  { code: '15536126', name: 'NANNING MASHAN CHANGJIANG RURAL BANK CORPORATION LIMITED' },
  { code: '15536111', name: 'NANNING XINGNING  CHANGJIANG RURAL BANK CORPORATION LIMITED' },
  { code: '16881448', name: 'Nanpi Rongxin County Bank Stock Co. Ltd.' },
  { code: '15212642', name: 'NeHe Rongxing Rural Bank' },
  { code: '3520000', name: 'NewUp Bank' },
  { code: '17148723', name: 'nignxaihuinonghelanshancunzhenyinhanggufenyouxiangongsi' },
  { code: '15212751', name: 'NingAn Rongxing Rural Bank' },
  { code: '15193481', name: 'Ningbo beilun BOC Fullerton Community Bank' },
  { code: '15193320', name: 'Ningbo Zhenhai BOC Fullerton bank' },
  { code: '15193322', name: 'Ninghai BOC Fullerton bank' },
  { code: '16221717', name: 'NingWu County RuiDu Village Bank Co.,LTD' },
  { code: '17148746', name: 'NingXia Pengyang Helanshan Village Bank' },
  { code: '17148732', name: 'Ningxia Qingtongxia Helanshan Village and Town Bank Co., Ltd' },
  { code: '16648737', name: 'NingXia TongXin JinHui County Bank' },
  { code: '16738743', name: 'NingXia XiJi HuiFa Village Bank Co.LTD' },
  { code: '17148715', name: 'NingXia xixia helanshan Village Bank Co.Ltd' },
  { code: '16738711', name: 'Ningxia yongning huifa country bank co. LTD' },
  { code: '16648741', name: 'NINGXIA YUANZHOU JINHUI RURAL BANK' },
  { code: '3300000', name: 'OCBC Wing Hang Bank (China) Limited' },
  { code: '29470608', name: 'Omnipay Inc' },
  { code: '3490000', name: 'onebank' },
  { code: '5342050', name: 'ORDOS COMMERCIAL BANK CO.,LTD.' },
  { code: '15422055', name: 'OTOG HUIZE VILLAGE BANK' },
  { code: '16087022', name: 'PAN ZHOU WAN HE COUNTRY BANK' },
  { code: '17073385', name: 'Panan WuShang rural Bank of Zhejiang Co.Ltd' },
  { code: '15406672', name: 'Pengshan Zhujiang Rural Bank' },
  { code: '15196621', name: 'Pengxi BOC Fullerton Community Bank' },
  { code: '15154251', name: 'PENGZE JIUYIN COUNTY BANK CO.,LTD' },
  { code: '5105840', name: 'Ping An Bank Company Ltd' },
  { code: '16776873', name: 'PINGCHNAG NOKE RURAL BANK' },
  { code: '15198245', name: 'pingchuan BOC Fullerton Community Bank' },
  { code: '16221651', name: 'PingDing Country ChangDu Village Bank CO.,LTD' },
  { code: '15218331', name: 'PingLiangKongTong Rongxing Rural Bank' },
  { code: '17251823', name: 'Pinglu County HeDong Village Bank CO.,LTD' },
  { code: '16041423', name: 'Pingquan Hengsheng County Bank Co.Ltd.' },
  { code: '17221759', name: 'PingYao County JinRong Community Bank CO.,LTD' },
  { code: '16844513', name: 'PINGYIN BLUE OCEAN COMMUNITY BANK CO.,LTD' },
  { code: '1009999', name: 'Postal Saving Bank of China' },
  { code: '1000000', name: 'Postal Savings and Remittance Office of State Post Bure' },
  { code: '17107073', name: 'PUAN PUHUI RURAL BANK CORP.,LTD.' },
  { code: '16665025', name: 'PUYANG ZHONGYUAN COUNTY BANK Co., Ltd' },
  { code: '15802514', name: 'Qian An Huimin Village Bank Company Limited' },
  { code: '15195375', name: 'Qianjiang BOC Fullerton bank' },
  { code: '15197954', name: 'Qianxian BOC Fullerton Bank' },
  { code: '15077071', name: 'Qianxinan Yilong SPD Rural Bank Co.Ltd.' },
  { code: '15283815', name: 'Qiao Chen Hushang Rural Bank' },
  { code: '15195338', name: 'QiCun FuDeng CunZhen Bank' },
  { code: '64094510', name: 'QiLu Bank' },
  { code: '15551263', name: 'Qin Huang Dao Fu Ning Jia Yin County Bank Co., Ltd.' },
  { code: '14498500', name: 'Qing Hai Sheng Rural Credit Union' },
  { code: '4504520', name: 'Qingdao bank' },
  { code: '15404520', name: 'Qingdao Chengyang Zhujiang Rural Bank' },
  { code: '14830000', name: 'Qingdao Rural Commercial Bank' },
  { code: '17358541', name: 'QINGHAI MENYUAN DATONG RURAL BANK CO.,LTD' },
  { code: '17358521', name: 'QINGHAI PINGAN DATONG RURAL BANK CO.,LTD' },
  { code: '14498501', name: 'QINGHAI RURAL CREDIT UNION' },
  { code: '17281261', name: 'Qinglong Rongxing County Bank Co.Ltd' },
  { code: '17107074', name: 'QINGLONG XINGAN RURAL BANK CORP.,LTD.' },
  { code: '15193432', name: 'Qingtian BOC Fullerton Overseas-Chinese Community Bank' },
  { code: '15194588', name: 'Qingzhou BOC Fullerton Bank' },
  { code: '17211672', name: 'Qinyuan County Changqing Village Bank CO.,LTD' },
  { code: '4384530', name: 'QISHANG BANK' },
  { code: '15194563', name: 'Qixia BOC Fullerton Bank' },
  { code: '15194921', name: 'Qixian BOC Fullerton Community Bank' },
  { code: '17221758', name: 'qixian jinrong community bank limited liability company' },
  { code: '16664972', name: 'QIXIAN ZHONGYUAN COUNTY BANK Co., Ltd' },
  { code: '15193754', name: 'Quanjiao BOC Fullerton Bank' },
  { code: '15194619', name: 'Qufu BOC Fullerton Bank' },
  { code: '16041283', name: 'Quzhou Hengsheng County Bank Co.,Ltd.' },
  { code: '17091327', name: 'Ren Xian Xtrcb County Bank Corporation Limited' },
  { code: '16844773', name: 'RIZHAO BLUE OCEAN COMMUNITY BANK CO.,LTD' },
  { code: '15154770', name: 'RIZHAO JIUYIN COUNTY BANK CORPORATION LIMITED' },
  { code: '17091365', name: 'RongCheng XTRCB County Bank Co.,Ltd' },
  { code: '15154242', name: 'RUICHANG JIUYIN COUNTY BANK CO.,LTD' },
  { code: '15238037', name: 'RURAL BANKING CORPORATION LIMITED' },
  { code: '15405881', name: 'Sanshui Zhujiang Rural Bank' },
  { code: '15806451', name: 'SANYA HUIMIN Village Bank Company Limited' },
  { code: '17317936', name: 'SHAANXI LONGXIAN CAB COMMUNITY BANK.' },
  { code: '17317933', name: 'SHAANXI QISHAN CAB COMMUNITY BANK Co.,Ltd.' },
  { code: '17317941', name: 'Shaanxi Taibai CAB Community Bank Co.,Ltd' },
  { code: '16864515', name: 'SHAN DONG SHANG HE HUI JIN RURAL BANK' },
  { code: '16864532', name: 'SHANDONG GAOQING HUIJIN RURAL BANK' },
  { code: '16754717', name: 'SHANDONG GUANXIAN QIFENG RURAL BANK' },
  { code: '16844615', name: 'SHANDONG JINXIANG BLUE OCEAN COMMUNITY BANK CO.,LTD' },
  { code: '16754618', name: 'SHANDONG SISHUI QIFENG RURAL BANK' },
  { code: '16754635', name: 'SHANDONG XINTAI QIFENG RURAL BANK' },
  { code: '16844743', name: 'SHANDONG YINAN BLUE OCEAN COMMUNITY BANK CO.,LTD.' },
  { code: '4012900', name: 'ShangHai Bank' },
  { code: '15192904', name: 'Shanghai pudong BOC Fullerton Community Bank' },
  { code: '3100000', name: 'Shanghai Pudong Development Bank' },
  { code: '15342904', name: 'SHANGHAI PUDONG JIANGNAN COUNTY BANK CO.,LTD' },
  { code: '15194332', name: 'Shangrao BOC Fullerton Bank' },
  { code: '5920000', name: 'SHANXI BANK CO.,LTD.' },
  { code: '16137953', name: 'shanxi jingyang tailong village bank' },
  { code: '16137935', name: 'shanxi meixian tailong village bank' },
  { code: '14551600', name: 'ShanXi Rural Credit Union' },
  { code: '15238034', name: 'SHANXI SHANGNAN JULI RURAL BANKING CORPORATION LIMITED' },
  { code: '16138019', name: 'shanxi xunyang tailong village bank' },
  { code: '15194755', name: 'Shanxian BOC Fullerton Bank' },
  { code: '14915820', name: 'Shaoguan Rural Commercial Bank Co.,Ltd' },
  { code: '17251719', name: 'ShenChi County HeDong Village Bank CO.,LTD' },
  { code: '15195089', name: 'shenqiu BOC Fullerton Community Bank' },
  { code: '15572210', name: 'Shenyang Yuhong Yongan County Bank Co. ,Ltd' },
  { code: '16171223', name: 'SHENZE LIFENG RURAL BANK' },
  { code: '16825845', name: 'SHENZHEN BAOAN GUIYIN COUNTY BANK' },
  { code: '15215841', name: 'Shenzhen Baoan Rongxing Rural Bank' },
  { code: '15195844', name: 'shenzhen longgang BOC Fullerton Community Bank' },
  { code: '15185848', name: 'ShenZhen Longhua Xinhua Villiage Township Bank' },
  { code: '16845841', name: 'SHENZHEN LUOHU BLUE OCEAN COMMUNITY BANK CO.,LTD' },
  { code: '15405847', name: 'SHENZHEN PINGSHAN ZHUJIANG RURAL BANK' },
  { code: '14040000', name: 'Shenzhen Rural Commercial Bank' },
  { code: '16573711', name: 'Shexian Jiayin Rural Bank of Anhui CO.,Ltd' },
  { code: '5438720', name: 'Shi Zui Shan CCB' },
  { code: '15009028', name: 'SHIHEZI BOCOM RURAL BANK' },
  { code: '16041217', name: 'Shijiazhuang Xinhua Hengsheng County Bank Co., Ltd.' },
  { code: '17197054', name: 'SHIQIAN CHANGZHENG RURAL BANK CO.,LTD.' },
  { code: '16221756', name: 'SHOUYANG COUNTRY HUIDU VILLAGE BANK' },
  { code: '15522422', name: 'SHU LAN JI YIN CUN ZHEN YIN RURAL BANK' },
  { code: '15802621', name: 'SHUANG CHENG HUIMIN Village Bank Company Limited' },
  { code: '15522433', name: 'SHUANG LIAO JI YIN CUN ZHEN YIN RURAL BANK' },
  { code: '64836560', name: 'SICHUAN BANK CO.,LTD.' },
  { code: '64966730', name: 'SICHUAN TIANFU BANK CO.,LTD' },
  { code: '3580000', name: 'SICHUAN XW BANK CORP.,LTD.' },
  { code: '17197055', name: 'SINAN CHANGZHENG RURAL BANK CO.,LTD' },
  { code: '15492436', name: 'Siping Tiedong Defeng Country Bank Co Ltd' },
  { code: '17012435', name: 'SIPINGTIEXI DUNYIN VILLAGE BANK CO.,LTD' },
  { code: '17197059', name: 'SONGTAO CHANGZHENG RURAL BANK CO.,LTD.' },
  { code: '15802515', name: 'Songyuan Ningjiang Huimin Village Bank Company Limited' },
  { code: '15195377', name: 'Songzi BOC Fullerton Bank' },
  { code: '15216624', name: 'Suining Anju Rongxing Rural Bank' },
  { code: '15193034', name: 'Suining BOC Fullerton Bank' },
  { code: '16087034', name: 'suiyang qianbei rural bank' },
  { code: '14283054', name: 'suzhou rural commercial bank' },
  { code: '14283050', name: 'suzhou rural commercial bank' },
  { code: '15193050', name: 'Suzhou Wujiang BOC Fullerton Bank' },
  { code: '15403057', name: 'SUZHOU WUZHONG ZHUJIANG RURAL BANK' },
  { code: '16649011', name: 'Tacheng Jinhui County Bank Company With Limited Liability' },
  { code: '15193725', name: 'Taihe BOC Fullerton Bank' },
  { code: '15194358', name: 'Taihe BOC Fullerton Community Bank' },
  { code: '15193163', name: 'taixing BOC Fullerton Community Bank' },
  { code: '4491610', name: 'Taiyuan City Commercial bank' },
  { code: '16221615', name: 'TAIYUAN JIANCAOPING XINDU VILLAGE BANK' },
  { code: '15551253', name: 'TANGSHAN KAIPING HUIJIN VILLAGE TOWM BANK' },
  { code: '15421358', name: 'TANGXIAN HUIZE VILLAGE BANK' },
  { code: '15195615', name: 'taojiang BOC Fullerton Community Bank' },
  { code: '15194541', name: 'tengzhou BOC Fullerton Community Bank' },
  { code: '14468700', name: 'The rural credit cooperatives of NingKia' },
  { code: '3420000', name: 'Tianjin Jincheng Bank' },
  { code: '15191136', name: 'Tianjin xiqing BOC Fullerton Community Bank' },
  { code: '17318256', name: 'TIANSHUI QINZHOU CAB COMMUNITY BANK.' },
  { code: '15218257', name: 'TianShuiMaiJi Rongxing Rural Bank' },
  { code: '17251632', name: 'TianZhen County HeDong Village Bank Co.,Ltd' },
  { code: '15572330', name: 'TLELING NONGSHANG COUNTY BANK' },
  { code: '16692457', name: 'TONG HUA ER DAO JIANG RUI FENG COUNTRY BANK Co., Ltd.' },
  { code: '15154321', name: 'TONGGU JIUYIN COUNTY BANK CO.,LTD' },
  { code: '16692451', name: 'TONGHUA RONGDA RONGTAI COUNTRY BANK CO.,LTD' },
  { code: '17342456', name: 'TONGHUADONGCHANGYUYINCUNZHENYINHANG' },
  { code: '15076915', name: 'TongLiang SPD RURAL Bank Co.,' },
  { code: '17197061', name: 'TONGREN WANSHAN CHANGZHENG RURAL BANK CO.CORP.' },
  { code: '15173354', name: 'TONGXIANG MINTAI RURAL BANK OF ZHEJIANG' },
  { code: '16884922', name: 'TongXu RongXin Rural Bank Co.,Ltd' },
  { code: '15197033', name: 'tongzi BOC Fullerton Community Bank' },
  { code: '15551391', name: 'TOWN BANK OF XINDA ZHANG BEI' },
  { code: '17012492', name: 'TUMEN DUNYIN VILLAGE BANK' },
  { code: '3340001', name: 'United Overseas Bank (China) Limited' },
  { code: '15804524', name: 'Village Bank Company Limited' },
  { code: '16692497', name: 'Wang Qing He Run Village Bank' },
  { code: '15183687', name: 'WANGJIANG XINHUA VILLAGE AND TOWNSHIP BANK' },
  { code: '16546425', name: 'WANNING JINGU COUNTRY BANK' },
  { code: '15551398', name: 'WanQuan Jiayin County Bank Co.,Ltd.' },
  { code: '16994591', name: 'WEIFANG WEICHENG BEIHAI RURAL BANK CO.LTD' },
  { code: '16524654', name: 'WeiHai FuMin Rural Bank Company Limited' },
  { code: '16994613', name: 'WEISHAN BEIHAI RURAL BANK CO.LTD' },
  { code: '15801466', name: 'WENAN HUIMIN Village Bank Company Limited' },
  { code: '15194652', name: 'wendeng BOC Fullerton Community Bank' },
  { code: '15537458', name: 'WENSHAN FUNING CHANGJIANG RURAL BANK CORPORATION LIMITED' },
  { code: '16221732', name: 'WENSHUI RUNDU VILLAGE BANK' },
  { code: '17221819', name: 'WenXi County JinRong Community Bank CO.,LTD' },
  { code: '3270000', name: 'Woori Bank (China) Limited' },
  { code: '15802624', name: 'WUCHANG HUIMIN Village Bank Company Limited' },
  { code: '15197037', name: 'wuchuan BOC Fullerton Community Bank' },
  { code: '4145210', name: 'Wuhan Commercial bank' },
  { code: '14595210', name: 'WUHAN RURAL COMMERCIAL BANK' },
  { code: '3560000', name: 'WUHANZBANK CO., LTD.' },
  { code: '15805964', name: 'WuHua HuiMin Village Bank co.,Ltd' },
  { code: '15193041', name: 'wujin BOC Fullerton Community Bank' },
  { code: '15194771', name: 'Wulian BOC Fullerton Bank' },
  { code: '16178811', name: 'WULUMUQIXIAN LIFENG RURAL BANK' },
  { code: '16214243', name: 'WuNing HengTong Rural Bank CO.,LTD' },
  { code: '16881446', name: 'Wuqiao Rongxin Rural Bank Stock Co.Ltd' },
  { code: '15196692', name: 'Wusheng BOC Fullerton Community Bank' },
  { code: '16179013', name: 'WUSU LIFENG RURAL BANK' },
  { code: '15196932', name: 'wuxi BOC Fullerton Community Bank' },
  { code: '3610000', name: 'WUXI XISHANG BANK' },
  { code: '16221669', name: 'WuXiang County ZeDu Village Bank CO.,LTD' },
  { code: '15195332', name: 'Wuxue BOC Fullerton Community Bank' },
  { code: '15193383', name: 'wuyi BOC Fullerton Community Bank' },
  { code: '17091484', name: 'Wuyi XTRCB County Bank Co.,Ltd.' },
  { code: '64020000', name: 'Xiamen Bank Co.,Ltd.' },
  { code: '4447910', name: 'XIAN BANK' },
  { code: '15188084', name: 'Xian Changan Xinhua Village Township Bnak' },
  { code: '16221775', name: 'xiang fen wan du village bank' },
  { code: '15195091', name: 'Xiangcheng BOC Fullerton Bank' },
  { code: '5295280', name: 'Xiangfan commercial bank' },
  { code: '5503320', name: 'XiangShan credit union' },
  { code: '15193111', name: 'Xiangshui BOC Fullerton Bank' },
  { code: '17251821', name: 'XiaXian HeDong Village Bank' },
  { code: '16376841', name: 'Xichang Jinxin rural bank limited liability company' },
  { code: '15214948', name: 'Xinan Rongxing Rural Bank' },
  { code: '16221726', name: 'XINFU XIUDU VILLAGE BANK' },
  { code: '15194356', name: 'xingan BOC Fullerton Community Bank' },
  { code: '15056413', name: 'XINGFU COUTY BANK CO.LTD' },
  { code: '15422038', name: 'XINGHE BAOSHANG VILLAGE BANK' },
  { code: '16562038', name: 'xinghemengshangcunzhenyinhang' },
  { code: '15405965', name: 'XINGNING ZHUJIANG RURAL BANK' },
  { code: '15197951', name: 'xingping BOC Fullerton Community Bank' },
  { code: '17107072', name: 'xingrenzhenxingcunzhenyinhanggufenyouxiangongsi' },
  { code: '17091312', name: 'XingTai County XTRCB County Bank Co.,Ltd' },
  { code: '16171234', name: 'XINGTANG LIFENG RURAL BANK' },
  { code: '15421735', name: 'XINGXIAN HUIZE VILLAGE BANK' },
  { code: '16174911', name: 'XINGYANG LIFENG RURAL BANK' },
  { code: '15406522', name: 'Xinjin Zhujiang Rural Bank' },
  { code: '16664989', name: 'XinXiang ZhongYuan Country Bank' },
  { code: '15405150', name: 'Xinyang zhujiang  rural bank' },
  { code: '15195143', name: 'xinye BOC Fullerton Community Bank' },
  { code: '15624913', name: 'XINZHENG ZHENGYIN COUNTRY BANK CO., LTD.' },
  { code: '16691364', name: 'Xiong Xian Feng Yuan County Bank' },
  { code: '16665115', name: 'XIPING ZHONGYUAN COUNTY BANK' },
  { code: '15193027', name: 'xishan BOC Fullerton Community Bank' },
  { code: '15197044', name: 'xishui BOC Fullerton Community Bank' },
  { code: '15154244', name: 'XIUSHUI JIUYIN COUNTY BANK CORPORATION LIMITED' },
  { code: '16631787', name: 'XIXIAN XINTIAN VILLAGE BANK' },
  { code: '15624971', name: 'XUNXIAN ZHENGYIN COUNTRY BANK COMPANY LTD' },
  { code: '15197959', name: 'xunyi BOC Fullerton Community Bank' },
  { code: '16692491', name: 'YAN JI HE RUN VILLAGE BANK CO.,LTD' },
  { code: '16221631', name: 'YangGao County XingDu Village Bank CO.,LTD' },
  { code: '15535992', name: 'YANGJIANG YANGCHUN CHANGJIANG RURAL BANG CORPORALITED' },
  { code: '16415222', name: 'Yangxin HanYin village bank Limited by Share Ltd' },
  { code: '17114663', name: 'YANGXIN HEHAI RURAL BANK CO.,LTD' },
  { code: '16503143', name: 'YANGZHONG HENGFENG RURAL BANK' },
  { code: '17197058', name: 'YANHE CHANGZHENG RURAL BANK CO.,LTD.' },
  { code: '15214949', name: 'Yanshi Rongxing Rural Bank' },
  { code: '15212619', name: 'Yanshou Rongxing Rural Bank' },
  { code: '14468702', name: 'Yellow River Rural Commercial Bank' },
  { code: '15766712', name: 'Yibin Xingyi Rural Co.,Ltd' },
  { code: '4325260', name: 'Yichang City Commercial Bank (CUP Data)' },
  { code: '4325210', name: 'Yichang Commercial bank' },
  { code: '15195282', name: 'yicheng BOC Fullerton Community Bank' },
  { code: '15194318', name: 'Yifeng BOC Fullerton Bank' },
  { code: '3530000', name: 'yillionbank' },
  { code: '4360010', name: 'Yinchuan City Commercial Bank (CUP Data Credit Card)' },
  { code: '15215354', name: 'Yingcheng Rongxing Rural Bank' },
  { code: '15193729', name: 'Yingshang BOC Fullerton Bank' },
  { code: '16221692', name: 'YingXian JinDu Village Bank CO.,LTD' },
  { code: '17197056', name: 'YINJIANG CHANGZHENG RURAL BANK CO.,LTD.' },
  { code: '15194737', name: 'Yishui BOC Fullerton bank' },
  { code: '16844337', name: 'YIYANG BLUE OCEAN COMMUNITY BANK' },
  { code: '16692421', name: 'YONG JI JIQING COUNTRY BANK CO.,LTD' },
  { code: '15521463', name: 'YONGQING JIYIN RURAL BANK CO,.LTD' },
  { code: '15197956', name: 'yongshou BOC Fullerton Community Bank' },
  { code: '17211693', name: 'Youyu County Changqing Village Bank CO.,LTD' },
  { code: '17342432', name: 'ytyyczyh' },
  { code: '17251824', name: 'YuanQu County HeDong Village Bank Co., Ltd.' },
  { code: '16441229', name: 'Yuanshi Xinrong Town Bank' },
  { code: '16625062', name: 'Yucheng Commercial Rural Bank Co.,Ltd' },
  { code: '15196691', name: 'Yuechi BOC Fullerton Community Bank' },
  { code: '15806063', name: 'Yunan Huimin Village Bank' },
  { code: '16994758', name: 'YUNCHENG BEIHAI RURAL BANK CO.,LTD' },
  { code: '16617362', name: 'Yunnan Malong BOB Rural Bank Co. ,Ltd.' },
  { code: '16617436', name: 'Yunnan Shiping BOB Rural Bank Co.,Ltd.' },
  { code: '16617418', name: 'Yunnan Xinping BOB Rural Bank Co.,Ltd' },
  { code: '16617325', name: 'Yunnan Xishan BOB Rural Bank Co. , Ltd.' },
  { code: '16617419', name: 'Yunnan YuanJiang BOB Rural Bank Co.,Ltd.' },
  { code: '17197053', name: 'YUPING CHANGZHENG RURAL BANK CO.,LTD.' },
  { code: '15197041', name: 'yuqing BOC Fullerton Community Bank' },
  { code: '15212419', name: 'Yushu Rongxing Rural Bank' },
  { code: '17231249', name: 'YuTian DaShang County Bank Co.,Ltd.' },
  { code: '15687410', name: 'YUXI HONGTA RURAL BANK CO.LTD.' },
  { code: '15551395', name: 'YUXIAN YINTAI RURAL BANK' },
  { code: '16691483', name: 'Zaoqiang Fengyuan County Bank Co.,Ltd.' },
  { code: '15195288', name: 'Zaoyang BOC Fullerton bank' },
  { code: '5824540', name: 'ZAOZHUANG BANK' },
  { code: '15551384', name: 'Zhangjiakou Xuanhua Jiayin County Bank Co., Ltd' },
  { code: '15174056', name: 'ZhangPing Mintai Rural Bank Of FuJian' },
  { code: '15572292', name: 'ZHANGWU JINTONG COUNTY BANK' },
  { code: '17124665', name: 'ZHANHUAQINGYUNBANK' },
  { code: '15535912', name: 'ZHANJIANG LIANJIANG CHANGJIANG RURAL BANG CORPORALITED' },
  { code: '15192763', name: 'zhaodong BOC Fullerton Community Bank' },
  { code: '15194562', name: 'zhaoyuan BOC Fullerton Community Bank' },
  { code: '16745068', name: 'Zhecheng Huanghuai Community Bank Co.,Ltd' },
  { code: '5253450', name: 'ZheJiang mintai commercial bank' },
  { code: '14293300', name: 'Zhejiang Rural Credit Union' },
  { code: '16213437', name: 'Zhejiang Songyang Hengtong Rural Bank' },
  { code: '16503311', name: 'ZHEJIANG TONGLU  HENGFENG RURAL BANK' },
  { code: '16613337', name: 'ZHEJIANG WENCHENG BOB RURAL BANK' },
  { code: '17107075', name: 'ZHENFENG XINGZHEN RURAL BANK CORP., LTD.' },
  { code: '15197035', name: 'zhengan BOC Fullerton Community Bank' },
  { code: '15422022', name: 'ZHENGLANQI HUIZE VILLAGE BANK' },
  { code: '4354910', name: 'Zhengzhou Commercial Bank' },
  { code: '15405071', name: 'Zhengzhou Zhujiang Rural Bank Co.,Ltd.' },
  { code: '15192477', name: 'zhenlai BOC Fullerton Community Bank' },
  { code: '16415264', name: 'Zhijiang HanYin village bank Limited by Share Ltd' },
  { code: '15216582', name: 'ZhongJiang Rongxing Rural Bank' },
  { code: '15624912', name: 'ZHONGMU ZHENGYIN COUNTRY BANK' },
  { code: '15406030', name: 'Zhongshang Dongfeng Zhujiang Rural Bank' },
  { code: '5864910', name: 'zhongyuan Bank' },
  { code: '65864910', name: 'ZHONGYUANBANK' },
  { code: '15194589', name: 'zhucheng BOC Fullerton Community Bank' },
  { code: '15925852', name: 'Zhuhai Hengqin Village Bank' },
  { code: '16565852', name: 'Zhuhai Nanping village bank' },
  { code: '16171401', name: 'ZHUOLU LIFENG RURAL BANK' },
  { code: '15215529', name: 'Zhuzhou Rongxing Rural Bank' },
  { code: '16994536', name: 'ZIBOBOSHANBEIHAIRURALBANK' },
  { code: '16994534', name: 'ZIBOZICHUAN BEIHAI RURAL BANK CO.,LTD' },
  { code: '15154379', name: 'ZIXI JIUYIN COUNTY BANK CO.,LTD' },
  { code: '14293301', name: 'ZJRCU' },
  { code: '15194612', name: 'zoucheng BOC Fullerton Community Bank' },
  { code: '17197045', name: 'ZUNYI XINPU CHANGZHENG RURAL BANK CORP.LTD' },
  { code: '17211637', name: 'Zuoyun County Changqing Village Bank CO.,LTD' },
] as const;
